import React, { useState } from 'react';
import { Form, Input, Button, Modal } from 'antd';
import { message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getHostName } from '../../utils/config';
import { getApiEndpoint } from '../../utils/config';
import './style.css';

const Login = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loginValues, setLoginValues] = useState(null);
  const [twoFactorForm] = Form.useForm();
  const navigate = useNavigate();

  const handleLogin = async (values, twofactor = null) => {
    setLoading(true);
    try {
      const requestBody = twofactor 
        ? { 
            user_id: loginValues.user_id,
            totp_code: twofactor
          }
        : {
            username: values.username,
            password: values.password,
            ...(values.totp_code ? { totp_code: values.totp_code } : {})
          };

      const endpoint = twofactor ? `${getApiEndpoint()}/api/verify_totp` : `${getApiEndpoint()}/api/login`;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        if (data.require_totp && !twofactor) {
          setLoginValues({
            user_id: data.user_id
          });
          setIsModalVisible(true);
        } else {
          localStorage.setItem('token', data.token);
          messageApi.success('登录成功');
          navigate('/dashboard');
        }
      } else {
        if (data.error === 'Invalid TOTP code') {
          messageApi.error('验证码错误，请重试');
          if (twofactor) {
            twoFactorForm.resetFields();
          }
        } else {
          messageApi.error(data.error || '登录失败');
          setIsModalVisible(false);
        }
      }
    } catch (error) {
      setIsModalVisible(false);
      messageApi.error('登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const onFinish = (values) => {
    handleLogin(values);
  };

  const handleTwoFactorSubmit = async () => {
    try {
      const values = await twoFactorForm.validateFields();
      handleLogin(null, values.twofactor);
    } catch (error) {
      messageApi.error('请输入验证码');
    }
  };

  return (     
    <div className="login-container">
       {contextHolder}
      <Modal
        title="两步验证"
        open={isModalVisible}
        onOk={handleTwoFactorSubmit}
        onCancel={() => {
          setIsModalVisible(false);
          twoFactorForm.resetFields();
        }}
        okText="确认"
        cancelText="取消"
        confirmLoading={loading}
      >
        <Form form={twoFactorForm}>
          <Form.Item
            name="twofactor"
            rules={[{ required: true, message: '请输入验证码!' }]}
          >
            <Input placeholder="请输入6位验证码" maxLength={6} />
          </Form.Item>
        </Form>
      </Modal>
      
      <div className="login-box">
        <h1>{getHostName()} Rialto</h1>
        <Form
          name="login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名!' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名" 
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="totp_code"
            rules={[{ required: false }]}
          >
            <Input
              placeholder="验证码（如已绑定TOTP）"
              size="large"
              maxLength={6}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-form-button" 
              size="large"
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
